import { render, staticRenderFns } from "./PatientViewRegimen.vue?vue&type=template&id=948ead92&scoped=true"
import script from "./PatientViewRegimen.vue?vue&type=script&lang=js"
export * from "./PatientViewRegimen.vue?vue&type=script&lang=js"
import style0 from "./PatientViewRegimen.vue?vue&type=style&index=0&id=948ead92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "948ead92",
  null
  
)

export default component.exports